import { render } from "./ModalDetalle.vue?vue&type=template&id=31a2ffc7&scoped=true"
import script from "./ModalDetalle.vue?vue&type=script&lang=js"
export * from "./ModalDetalle.vue?vue&type=script&lang=js"

import "./ModalDetalle.vue?vue&type=style&index=0&id=31a2ffc7&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a2ffc7"]])

export default __exports__